import { render, staticRenderFns } from "./issuable_label_selector.vue?vue&type=template&id=da4862be"
import script from "./issuable_label_selector.vue?vue&type=script&lang=js"
export * from "./issuable_label_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports